import * as React from 'react'
import { useTheme } from 'styled-components'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import {
  modalAnimationDuration,
  standardModalBodyOpenClassName,
  standardModalPortalClassName,
} from '../../../brunswick/styles/constants'
import { EmbroideryService } from '../../../containers/EmbroideryService'
import { EmbroideryModalService } from '../../../containers/EmbroideryService/EmbroideryModalService'
import { Embroidery } from '../../../types/graphql'
// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../modals/NextModal'
import { EmbroideryModalPreview } from '../EmbroideryModalPreview'

import { EmbroideryModalHeader } from './EmbroideryModalHeader'
import { ModalEmbroideryOptions } from './EmbroideryOptionSelector/EmbroideryOptionSelector'
import * as Styles from './styles'

export const EmbroideryModal: React.FC<{
  embroideryOptions: ReadonlyArray<Embroidery>
  heapCtaAction?: string
}> = ({ embroideryOptions, heapCtaAction }) => {
  const {
    embroidery: { modal: strings, embroideryOptionTitles, close },
  } = useTranslation()
  const {
    currentlySelectedFormOption,
    setPreviewItemsByKind,
    setSelectedFormKind,
    selectedEmbroideryOptions,
    selectedFormKind,
  } = EmbroideryService.useContainer()

  const { shouldDisplayEmbroideryModal, closeEmbroideryModal, onAfterEmbroideryModalClose } =
    EmbroideryModalService.useContainer()

  const theme = useTheme()
  const closeBtnRef = React.useRef<HTMLButtonElement>(null)

  const headerTitle = currentlySelectedFormOption
    ? embroideryOptionTitles[currentlySelectedFormOption?.kind]
    : strings.title

  const handleBackButtonClick = () => {
    if (typeof selectedFormKind === 'string' && !selectedEmbroideryOptions[selectedFormKind]) {
      setPreviewItemsByKind(prev => ({
        ...prev,
        [selectedFormKind]: [],
      }))
    }
    setSelectedFormKind(null)
  }

  return (
    <NextModal
      bodyOpenClassName={standardModalBodyOpenClassName}
      testId='embroidery-modal'
      closeTimeoutMS={modalAnimationDuration}
      isOpen={shouldDisplayEmbroideryModal}
      onRequestClose={closeEmbroideryModal}
      onAfterClose={onAfterEmbroideryModalClose}
      onAfterOpen={() => closeBtnRef.current?.focus()}
      portalClassName={standardModalPortalClassName}
      style={Styles.deriveModalStyles(theme)}
    >
      <Styles.Body>
        <EmbroideryModalHeader.Wrapper>
          <EmbroideryModalHeader.Section>
            {selectedFormKind !== null ? (
              <EmbroideryModalHeader.BackButton handleClick={handleBackButtonClick} />
            ) : null}
            <EmbroideryModalHeader.CloseButtonDesktop
              onClick={closeEmbroideryModal}
              ref={closeBtnRef}
              text={close}
            />
          </EmbroideryModalHeader.Section>
          <EmbroideryModalHeader.Title>{headerTitle}</EmbroideryModalHeader.Title>
          <EmbroideryModalHeader.Section>
            <EmbroideryModalHeader.CloseButtonMobile
              onClick={closeEmbroideryModal}
              ref={closeBtnRef}
            />
          </EmbroideryModalHeader.Section>
        </EmbroideryModalHeader.Wrapper>
        <Styles.Container>
          <Styles.Section>
            <Styles.ImageHeader>
              <Styles.Title>{strings.previewTitle}</Styles.Title>
              <Styles.Subtitle>{strings.previewSubtitle}</Styles.Subtitle>
            </Styles.ImageHeader>
            <Styles.ImagePreviewWrap>
              <EmbroideryModalPreview />
            </Styles.ImagePreviewWrap>
          </Styles.Section>
          <Styles.Section>
            <ModalEmbroideryOptions
              embroideryOptions={embroideryOptions}
              heapCtaAction={heapCtaAction}
              handleBackButtonClick={handleBackButtonClick}
            />
          </Styles.Section>
        </Styles.Container>
      </Styles.Body>
    </NextModal>
  )
}
